var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dryingProgressChartData)?_c('drying-progress',{staticClass:"panel-card-drying-progress",attrs:{"chartData":_vm.dryingProgressChartData.chartData,"options":_vm.dryingProgressChartData.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }